import { ChainID } from '@ankr.com/chains-list';
import { IUsageTopElement } from 'multirpc-sdk';

import { RootState } from 'store';
import { isObjectEmpty } from 'modules/common/utils/isObjectEmpty';
import {
  selectAllPathsByChainId,
  selectBlockchainBySubchainId,
  selectChainIdsByPaths,
} from 'modules/chains/store/selectors';

import { sumBlockchainsCountsByChainPaths } from './sumBlockchainsCountsByChainPaths';

export type AggregatedBlockchainsCountsByChainID = Record<ChainID, number>;

const defaultAggregation = {} as AggregatedBlockchainsCountsByChainID;

export const aggregateBlockchainsCountsByChainID = (
  state: RootState,
  blockchainsCounts: IUsageTopElement[],
) => {
  const result = blockchainsCounts.reduce((aggregation, { name }) => {
    const [currentChainId] = selectChainIdsByPaths(state, [name]);

    const currentChainMainId = selectBlockchainBySubchainId(
      state,
      currentChainId,
    )?.id;

    if (!currentChainMainId) {
      return aggregation;
    }

    const subchainPaths = selectAllPathsByChainId(state, currentChainMainId);

    const aggregatedStatsByChain = sumBlockchainsCountsByChainPaths({
      blockchainsCounts,
      chainPaths: subchainPaths,
    });

    aggregation[currentChainMainId] = aggregatedStatsByChain;

    return aggregation;
  }, {} as AggregatedBlockchainsCountsByChainID);

  return isObjectEmpty(result) ? defaultAggregation : result;
};
